import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import InventoryTable from './InventoryTable';
import OrdersTable from './OrdersTable';
import ReturnsTable from './ReturnsTable';
import MedicineRateReport from './MedicineRateReport';

const TABS = [
  { to: "/main/inventory/inventory", label: "Inventory" },
  { to: "/main/inventory/Distributors", label: "Distributors" },
  { to: "/main/inventory/Order", label: "Orders" },
  { to: "/main/inventory/Returns", label: "Returns" },
  { to: "/main/inventory/medicines", label: "Medicines" },
  { to: "/main/inventory/RateReport", label: "Medicine Rate Report" },
];

const InventoryPanel = () => {
  const { section } = useParams();

  return (
    <div className="min-h-screen w-full bg-slate-50 px-4 py-6 md:px-8">
      {/* Navigation Tabs */}
      <div className="mb-5">
        <div className="inline-flex w-fit max-w-full flex-wrap gap-1 rounded-xl border border-slate-200 bg-slate-100 p-1">
          {TABS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-lg px-4 py-1.5 text-sm font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 ${
                  isActive ? 'bg-white text-sky-700 shadow-sm' : 'text-slate-600 hover:bg-white/60 hover:text-slate-900'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="min-h-[60vh] rounded-2xl border border-slate-200 bg-white p-4 shadow-sm md:p-6">
        {/* Orders and Returns list rows by their shared id, so each has its own table. */}
        {section === 'Order' ? (
          <OrdersTable />
        ) : section === 'Returns' ? (
          <ReturnsTable />
        ) : section === 'RateReport' ? (
          <MedicineRateReport />
        ) : (
          <InventoryTable listType={section} />
        )}
      </div>
    </div>
  );
};

export default InventoryPanel;
